import Glide, { Controls, Keyboard, Breakpoints, Swipe } from '@glidejs/glide/dist/glide.modular.esm'
import device from '../helpers/device'
import refs from '../helpers/refs'

class CRecipeSlider {
  constructor (el) {
    this.component = el
    this.$refs = refs(this.component)
    this.init()
  }

  init () {
    this.glide = new Glide(this.$refs.slider, {
      type: 'slider',
      animationDuration: device.isMobile() ? 250 : 400,
      gap: 32,
      rewind: false,
      perView: 4.2,
      bound: true,
      breakpoints: {
        350: {
          perView: 1.0,
          gap: 16
        },
        860: {
          perView: 1.15,
          gap: 16
        },
        1200: {
          perView: 2.2,
          gap: 16
        },
        1366: {
          perView: 2.8,
          gap: 32
        },
        1680: {
          perView: 3.2,
          gap: 32
        },
        1920: {
          perView: 3.4,
          gap: 32
        }
      }
    }).mount({ Controls, Keyboard, Breakpoints, Swipe })

    this.glide.on('run', () => {
      this.setControls(this.glide.index)
    })

    // Adding aria-hidden property to clones
    const cloneSelector = `.${this.glide.settings.classes.cloneSlide}`
    this.$refs.slider
      .querySelectorAll(cloneSelector)
      .forEach(el => el.setAttribute('aria-hidden', 'true'))

    this.$refs.controls?.forEach((control) => {
      control.addEventListener('click', (e) => {
        e.preventDefault()
        const index = parseInt(control.getAttribute('data-index'))
        this.glide.go(`=${index}`)
        this.setControls(index)
      })
    })

    this.setControls(0)
  }

  setControls (index) {
    // Slider: Recipe Slider Focus
    this.$refs.controls?.forEach((control) => {
      if (parseInt(control.getAttribute('data-index')) === index) {
        control.classList.add('c-recipe-slider__control-button--active')
      } else {
        control.classList.remove('c-recipe-slider__control-button--active')
      }
    })

    if (!Array.isArray(this.$refs.prevRecipe)) {
      this.$refs.prevRecipe = [this.$refs.prevRecipe]
    }
    if (!Array.isArray(this.$refs.nextRecipe)) {
      this.$refs.nextRecipe = [this.$refs.nextRecipe]
    }

    // Button: Previous Recipe
    this.$refs.prevRecipe.forEach((button) => {
      button.addEventListener('click', (e) => {
        // Handle iOS Safari's buggy click event behavior
        e.preventDefault()
        e.stopPropagation()

        this.glide.go('<')
      })
    })

    // Button: Next Recipe
    this.$refs.nextRecipe.forEach((button) => {
      button.addEventListener('click', (e) => {
        // Handle iOS Safari's buggy click event behavior
        e.preventDefault()
        e.stopPropagation()

        this.glide.go('>')
      })
    })
  }
}

// Wait for images to load in
window.addEventListener('load', () => {
  document
    .querySelectorAll('[data-c-recipe-slider]')
    .forEach(el => new CRecipeSlider(el))
})
